module.exports = __webpack_public_path__ + "static/media/sm_trip_advisor.bb1825f8.svg";